import { render, staticRenderFns } from "./IconSatisSurvey.vue?vue&type=template&id=9d60f99c&"
import script from "./IconSatisSurvey.vue?vue&type=script&lang=js&"
export * from "./IconSatisSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports